// 통합 메인 히어로 배경 헥사곤 모티프 (정적 · 애니메이션 없음)
// 좌표는 viewBox 0 0 1200 760 기준 사전 계산값.
// 사용법:
//   1) <header className="mh-hero"> 의 "첫 자식"으로 <HeroHexes /> 삽입
//   2) .mh-hero 는 position:relative; overflow:hidden (기존 그대로),
//      콘텐츠(.mh-hero__inner / .mh-pillars)는 z-index:1 (기존 그대로)
//   강도는 opacity prop 으로 조절: 0.55(옅게) ~ 0.82(기본) ~ 1(진하게)

export default function HeroHexes({ opacity = 0.82 }: { opacity?: number }) {
  return (
    <svg
      viewBox="0 0 1200 760"
      preserveAspectRatio="xMidYMid slice"
      aria-hidden
      style={{
        position: 'absolute',
        inset: 0,
        width: '100%',
        height: '100%',
        zIndex: 0,
        pointerEvents: 'none',
        opacity,
      }}
    >
      {/* 우상단 대형: 면 채움 + 외곽선 (레드 워시 영역 → 레드) */}
      <polygon points="1050,8 1173,79 1173,221 1050,292 927,221 927,79" fill="#b8313d" fillOpacity={0.05} />
      <polygon
        points="1050,8 1173,79 1173,221 1050,292 927,221 927,79"
        fill="none"
        stroke="#b8313d"
        strokeWidth={1.4}
        strokeOpacity={0.34}
      />
      {/* 우중단 소형 (레드) */}
      <polygon
        points="958,416 1003,442 1003,494 958,520 913,494 913,442"
        fill="none"
        stroke="#b8313d"
        strokeWidth={1.3}
        strokeOpacity={0.28}
      />
      {/* 우하단 중형 (레드) */}
      <polygon
        points="1142,474 1216.5,517 1216.5,603 1142,646 1067.5,603 1067.5,517"
        fill="none"
        stroke="#b8313d"
        strokeWidth={1.2}
        strokeOpacity={0.22}
      />
      {/* 좌하단 (그레이) */}
      <polygon
        points="108,478 215.4,540 215.4,664 108,726 0.6,664 0.6,540"
        fill="none"
        stroke="#8494ae"
        strokeWidth={1.4}
        strokeOpacity={0.2}
      />
    </svg>
  );
}
